// extracted by mini-css-extract-plugin
export default {"input":"InputText_input_NOUFH"};